import { render, staticRenderFns } from "./reports.vue?vue&type=template&id=ffd24c40&scoped=true"
import script from "./reports.vue?vue&type=script&lang=js"
export * from "./reports.vue?vue&type=script&lang=js"
import style0 from "./reports.vue?vue&type=style&index=0&id=ffd24c40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffd24c40",
  null
  
)

export default component.exports